export default "__VITE_ASSET__CPOGM8tH__"